import { ConfirmDialog } from '../../../shared/ui';

type UnsavedChangesModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
};

export const UnsavedChangesModal = ({ isOpen, onStay, onLeave }: UnsavedChangesModalProps) => (
  <ConfirmDialog
    isOpen={isOpen}
    title="Несохранённые изменения"
    message="В форме есть несохранённые изменения. Если вы продолжите, они будут потеряны."
    cancelText="Остаться"
    confirmText="Не сохранять"
    onCancel={onStay}
    onConfirm={onLeave}
  />
);
